module.exports = __webpack_public_path__ + "img/124.10.2fb65662.png";